module.exports = __webpack_public_path__ + "media/images/link-sent-96985f61.svg";